import { Component, OnInit, OnDestroy } from "@angular/core";
import { DataService_expressadmin } from "../shared/data.service";

import { wsOneCardExpressAdminPrintQueueStatusInfo } from "../shared/wsOneCardExpressAdminPrintQueueStatusInfo";
import { wsAdminIDDepotPrintQueueInfo } from "../shared/wsOneCardExpressAdminDataInfo";
import { wsOneCardExpressAdminStatusChangeParm } from "../shared/wsOneCardExpressAdminStatusChangeParm";
import { wsOneCardExpressAdminStatusChangeItems } from "../shared/wsOneCardExpressAdminStatusChangeParm";

import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
	selector: "app-root",
	templateUrl: "./status.component.html",
	styleUrls: ["./status.component.css"],
	providers: [ConfirmationService],
})
export class StatusComponent implements OnInit, OnDestroy {
	constructor(
		private dataService: DataService_expressadmin,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		public dialogConfig: DynamicDialogConfig
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public UserPersonID: number;
	public SchoolID: number;

	public lstPrintQueueChecked: wsAdminIDDepotPrintQueueInfo[] = [];
	public lstPrintQueueStatus: wsOneCardExpressAdminPrintQueueStatusInfo[] = [];
	public SelectedPrintQueueStatus: wsOneCardExpressAdminPrintQueueStatusInfo;

	public ItemCount: number = 0;
	public Comment: string = "";
	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.UserPersonID = this.dialogConfig.data.UserPersonID;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.lstPrintQueueChecked = this.dialogConfig.data.lstPrintQueueChecked;

		this.isBusy = true;
		this.dataService.OneCardExpressAdminPrintQueueStatusSelectList().subscribe((data) => this.OneCardExpressAdminPrintQueueStatusSelectList_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	OneCardExpressAdminPrintQueueStatusSelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	OneCardExpressAdminPrintQueueStatusSelectList_Complete(data: any) {
		this.lstPrintQueueStatus = data;

		this.ItemCount = this.lstPrintQueueChecked.length;
		this.SelectedPrintQueueStatus = this.lstPrintQueueStatus[0];

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStatusChange
	//
	//-----------------------------------------------------------------------------------------------------
	onStatusChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	onUpdate() {
		if (this.lstPrintQueueChecked.length > 5) {
			this.confirmationService.confirm({
				acceptLabel: "Yes",
				rejectVisible: true,
				message: "You are about to change more then 5 print queue items. <br><br> Are you sure?",
				header: "Change Status",
				icon: "fa fa-info",
				accept: () => {
					this.ProcessStatusChange();
				},
				reject: () => {},
			});

			return;
		} else {
			this.ProcessStatusChange();
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ProcessStatusChange
	//
	//-----------------------------------------------------------------------------------------------------
	ProcessStatusChange() {
		let parms: wsOneCardExpressAdminStatusChangeParm = {
			AdministratorPersonID: this.UserPersonID,
			IDDepotPrintQueueStatusID: this.SelectedPrintQueueStatus.IDDepotPrintQueueStatusID,
			Comment: this.Comment,
			PrintQueueItems: [],
		};

		this.lstPrintQueueChecked.forEach((item) => {
			let r: wsOneCardExpressAdminStatusChangeItems = {
				IDDepotPrintQueueID: item.IDDepotPrintQueueID,
			};

			parms.PrintQueueItems.push(r);
		});

		this.isBusy = true;
		this.dataService.OneCardExpressAdminStatusChange(parms).subscribe((data) => this.OneCardExpressAdminStatusChange_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	OneCardExpressAdminStatusChange_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	OneCardExpressAdminStatusChange_Complete(data: any) {
		this.isBusy = false;

		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(1);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
